module.exports = __webpack_public_path__ + "static/media/Cam_1.aa6200be.webp";